<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Noty'" [name]="'Dodaj notę'"
                xmlns="http://www.w3.org/1999/html"></app-breadcrumb>
<div class="invoice-note-create" [formGroup]="invoiceNoteForm" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="(!invoiceNoteForm.valid || disabledInvoiceNote) && blockSubmit" mat-stroked-button
            color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card fxLayout="column" fxLayoutGap="15px">
        <div fxLayout="row">
          <h3>Dane noty</h3>
        </div>
        <app-dict
          [label]="'Firma'" [dictType]="'company'"
          [control]="companyControl"
          [required]="true"
          [multiple]="false"
        ></app-dict>
        <app-dict-all-contracts
          fxFlex="100" label="Umowa"
          [control]="contractControl"
          [required]="true"
          [companyId]="companyId"
          (selectedContract)="contractChanged($event)"
          [showOwnerName]="true"
          [showStatus]="true"
          [partnershipContracts]="true"
        ></app-dict-all-contracts>

        <mat-form-field fxFlex="100">
          <mat-label>Kwota</mat-label>
          <input [required]="true" type="number" matInput placeholder="Kwota" [formControl]="grossControl">
          <mat-error *ngIf="grossControl.hasError('required')">To pole jest wymagane</mat-error>
          <mat-error *ngIf="grossControl.hasError('backendError')">{{grossControl.getError('backendError')}}</mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="100">
          <mat-label>Powód wystawienia noty</mat-label>
          <input [required]="true" matInput placeholder="Powód wystawienia noty" [formControl]="reasonControl">
          <mat-error *ngIf="reasonControl.hasError('required')">Musisz podać powód</mat-error>
        </mat-form-field>

      </mat-card>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="(!invoiceNoteForm.valid || disabledInvoiceNote) && blockSubmit" mat-stroked-button
            color="primary">
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn">
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>
</div>
